import { Link } from "lucide-react"

import { useUi } from "@/core/i18n/locale-context"

interface SourceLineProps {
  /** At least one source: no source, no claim. */
  sources: [{ label: string; href: string }, ...{ label: string; href: string }[]]
  /** Financial year the figure applies to, e.g. "2026–27". Required for ATO figures. */
  financialYear?: string
  /** Date the source was last checked, e.g. "27 Oct 2026". */
  checked: string
}

export const SourceLine = ({ sources, financialYear, checked }: SourceLineProps) => {
  const ui = useUi()
  return (
    <p className="text-muted-foreground flex items-start gap-1.5 text-xs leading-snug">
      <Link className="mt-0.5 size-3.5 shrink-0" aria-hidden="true" />
      <span>
        {ui.sourcePrefix}{" "}
        {sources.map(({ label, href }, i) => (
          <span key={href}>
            {i > 0 && " · "}
            <a href={href} className="hover:text-foreground underline underline-offset-2">
              {label}
            </a>
          </span>
        ))}
        {financialYear && ` · ${ui.financialYear(financialYear)}`} · {ui.checkedOn(checked)}
      </span>
    </p>
  )
}
